/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as StoreLayoutRouteImport } from './routes/$store/_layout'
import { Route as AuthAuthLayoutRouteImport } from './routes/_auth/_auth-layout'
import { Route as StoreLayoutIndexRouteImport } from './routes/$store/_layout/index'
import { Route as StoreLayoutAttributesRouteImport } from './routes/$store/_layout/attributes'
import { Route as StoreLayoutCategoriesRouteImport } from './routes/$store/_layout/categories'
import { Route as StoreLayoutCollectionsRouteImport } from './routes/$store/_layout/collections'
import { Route as StoreLayoutCouponsRouteImport } from './routes/$store/_layout/coupons'
import { Route as StoreLayoutCustomersRouteImport } from './routes/$store/_layout/customers'
import { Route as StoreLayoutImagesRouteImport } from './routes/$store/_layout/images'
import { Route as StoreLayoutOrdersRouteImport } from './routes/$store/_layout/orders'
import { Route as StoreLayoutPersonalizationRouteImport } from './routes/$store/_layout/personalization'
import { Route as StoreLayoutProductionRouteImport } from './routes/$store/_layout/production'
import { Route as StoreLayoutProductsRouteImport } from './routes/$store/_layout/products'
import { Route as StoreLayoutPromotionsRouteImport } from './routes/$store/_layout/promotions'
import { Route as StoreLayoutReturnsRouteImport } from './routes/$store/_layout/returns'
import { Route as StoreLayoutReviewsRouteImport } from './routes/$store/_layout/reviews'
import { Route as StoreLayoutSettingsRouteImport } from './routes/$store/_layout/settings'
import { Route as StoreLayoutSiteCustomizationRouteImport } from './routes/$store/_layout/site-customization'
import { Route as StoreLayoutTagsRouteImport } from './routes/$store/_layout/tags'
import { Route as AuthAuthLayoutForgotPasswordRouteImport } from './routes/_auth/_auth-layout/forgot-password'
import { Route as AuthAuthLayoutResetPasswordRouteImport } from './routes/_auth/_auth-layout/reset-password'
import { Route as AuthAuthLayoutSigninRouteImport } from './routes/_auth/_auth-layout/signin'
import { Route as StoreLayoutAdminFeatureAnnouncementsRouteImport } from './routes/$store/_layout/admin_.feature-announcements'
import { Route as StoreLayoutAdminPaymentMethodsRouteImport } from './routes/$store/_layout/admin_.payment-methods'
import { Route as StoreLayoutAdminShippingMethodsRouteImport } from './routes/$store/_layout/admin_.shipping-methods'
import { Route as StoreLayoutOrdersOrderIdRouteImport } from './routes/$store/_layout/orders_.$orderId'
import { Route as StoreLayoutProductsAddRouteImport } from './routes/$store/_layout/products_.add'
import { Route as StoreLayoutSettingsApiRouteImport } from './routes/$store/_layout/settings_.api'
import { Route as StoreLayoutSettingsGeneralRouteImport } from './routes/$store/_layout/settings_.general'
import { Route as StoreLayoutSettingsPaymentRouteImport } from './routes/$store/_layout/settings_.payment'
import { Route as StoreLayoutSettingsSeoRouteImport } from './routes/$store/_layout/settings_.seo'
import { Route as StoreLayoutSettingsShippingRouteImport } from './routes/$store/_layout/settings_.shipping'
import { Route as StoreLayoutSettingsTeamRouteImport } from './routes/$store/_layout/settings_.team'
import { Route as StoreLayoutAdminFeatureAnnouncementsNewRouteImport } from './routes/$store/_layout/admin_.feature-announcements_.new'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreLayoutRoute = StoreLayoutRouteImport.update({
  id: '/$store/_layout',
  path: '/$store',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAuthLayoutRoute = AuthAuthLayoutRouteImport.update({
  id: '/_auth/_auth-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreLayoutIndexRoute = StoreLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutAttributesRoute = StoreLayoutAttributesRouteImport.update({
  id: '/attributes',
  path: '/attributes',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutCategoriesRoute = StoreLayoutCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutCollectionsRoute = StoreLayoutCollectionsRouteImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutCouponsRoute = StoreLayoutCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutCustomersRoute = StoreLayoutCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutImagesRoute = StoreLayoutImagesRouteImport.update({
  id: '/images',
  path: '/images',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutOrdersRoute = StoreLayoutOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutPersonalizationRoute =
  StoreLayoutPersonalizationRouteImport.update({
    id: '/personalization',
    path: '/personalization',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutProductionRoute = StoreLayoutProductionRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutProductsRoute = StoreLayoutProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutPromotionsRoute = StoreLayoutPromotionsRouteImport.update({
  id: '/promotions',
  path: '/promotions',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutReturnsRoute = StoreLayoutReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutReviewsRoute = StoreLayoutReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutSettingsRoute = StoreLayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutSiteCustomizationRoute =
  StoreLayoutSiteCustomizationRouteImport.update({
    id: '/site-customization',
    path: '/site-customization',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutTagsRoute = StoreLayoutTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const AuthAuthLayoutForgotPasswordRoute =
  AuthAuthLayoutForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutResetPasswordRoute =
  AuthAuthLayoutResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => AuthAuthLayoutRoute,
  } as any)
const AuthAuthLayoutSigninRoute = AuthAuthLayoutSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthAuthLayoutRoute,
} as any)
const StoreLayoutAdminFeatureAnnouncementsRoute =
  StoreLayoutAdminFeatureAnnouncementsRouteImport.update({
    id: '/admin_/feature-announcements',
    path: '/admin/feature-announcements',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutAdminPaymentMethodsRoute =
  StoreLayoutAdminPaymentMethodsRouteImport.update({
    id: '/admin_/payment-methods',
    path: '/admin/payment-methods',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutAdminShippingMethodsRoute =
  StoreLayoutAdminShippingMethodsRouteImport.update({
    id: '/admin_/shipping-methods',
    path: '/admin/shipping-methods',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutOrdersOrderIdRoute =
  StoreLayoutOrdersOrderIdRouteImport.update({
    id: '/orders_/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutProductsAddRoute = StoreLayoutProductsAddRouteImport.update({
  id: '/products_/add',
  path: '/products/add',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutSettingsApiRoute = StoreLayoutSettingsApiRouteImport.update({
  id: '/settings_/api',
  path: '/settings/api',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutSettingsGeneralRoute =
  StoreLayoutSettingsGeneralRouteImport.update({
    id: '/settings_/general',
    path: '/settings/general',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutSettingsPaymentRoute =
  StoreLayoutSettingsPaymentRouteImport.update({
    id: '/settings_/payment',
    path: '/settings/payment',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutSettingsSeoRoute = StoreLayoutSettingsSeoRouteImport.update({
  id: '/settings_/seo',
  path: '/settings/seo',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutSettingsShippingRoute =
  StoreLayoutSettingsShippingRouteImport.update({
    id: '/settings_/shipping',
    path: '/settings/shipping',
    getParentRoute: () => StoreLayoutRoute,
  } as any)
const StoreLayoutSettingsTeamRoute = StoreLayoutSettingsTeamRouteImport.update({
  id: '/settings_/team',
  path: '/settings/team',
  getParentRoute: () => StoreLayoutRoute,
} as any)
const StoreLayoutAdminFeatureAnnouncementsNewRoute =
  StoreLayoutAdminFeatureAnnouncementsNewRouteImport.update({
    id: '/admin_/feature-announcements_/new',
    path: '/admin/feature-announcements/new',
    getParentRoute: () => StoreLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/onboarding': typeof OnboardingRoute
  '/$store': typeof StoreLayoutRouteWithChildren
  '/': typeof AuthAuthLayoutRouteWithChildren
  '/$store/attributes': typeof StoreLayoutAttributesRoute
  '/$store/categories': typeof StoreLayoutCategoriesRoute
  '/$store/collections': typeof StoreLayoutCollectionsRoute
  '/$store/coupons': typeof StoreLayoutCouponsRoute
  '/$store/customers': typeof StoreLayoutCustomersRoute
  '/$store/images': typeof StoreLayoutImagesRoute
  '/$store/orders': typeof StoreLayoutOrdersRoute
  '/$store/personalization': typeof StoreLayoutPersonalizationRoute
  '/$store/production': typeof StoreLayoutProductionRoute
  '/$store/products': typeof StoreLayoutProductsRoute
  '/$store/promotions': typeof StoreLayoutPromotionsRoute
  '/$store/returns': typeof StoreLayoutReturnsRoute
  '/$store/reviews': typeof StoreLayoutReviewsRoute
  '/$store/settings': typeof StoreLayoutSettingsRoute
  '/$store/site-customization': typeof StoreLayoutSiteCustomizationRoute
  '/$store/tags': typeof StoreLayoutTagsRoute
  '/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/reset-password': typeof AuthAuthLayoutResetPasswordRoute
  '/signin': typeof AuthAuthLayoutSigninRoute
  '/$store/': typeof StoreLayoutIndexRoute
  '/$store/admin/feature-announcements': typeof StoreLayoutAdminFeatureAnnouncementsRoute
  '/$store/admin/payment-methods': typeof StoreLayoutAdminPaymentMethodsRoute
  '/$store/admin/shipping-methods': typeof StoreLayoutAdminShippingMethodsRoute
  '/$store/orders/$orderId': typeof StoreLayoutOrdersOrderIdRoute
  '/$store/products/add': typeof StoreLayoutProductsAddRoute
  '/$store/settings/api': typeof StoreLayoutSettingsApiRoute
  '/$store/settings/general': typeof StoreLayoutSettingsGeneralRoute
  '/$store/settings/payment': typeof StoreLayoutSettingsPaymentRoute
  '/$store/settings/seo': typeof StoreLayoutSettingsSeoRoute
  '/$store/settings/shipping': typeof StoreLayoutSettingsShippingRoute
  '/$store/settings/team': typeof StoreLayoutSettingsTeamRoute
  '/$store/admin/feature-announcements/new': typeof StoreLayoutAdminFeatureAnnouncementsNewRoute
}
export interface FileRoutesByTo {
  '/onboarding': typeof OnboardingRoute
  '/': typeof AuthAuthLayoutRouteWithChildren
  '/$store/attributes': typeof StoreLayoutAttributesRoute
  '/$store/categories': typeof StoreLayoutCategoriesRoute
  '/$store/collections': typeof StoreLayoutCollectionsRoute
  '/$store/coupons': typeof StoreLayoutCouponsRoute
  '/$store/customers': typeof StoreLayoutCustomersRoute
  '/$store/images': typeof StoreLayoutImagesRoute
  '/$store/orders': typeof StoreLayoutOrdersRoute
  '/$store/personalization': typeof StoreLayoutPersonalizationRoute
  '/$store/production': typeof StoreLayoutProductionRoute
  '/$store/products': typeof StoreLayoutProductsRoute
  '/$store/promotions': typeof StoreLayoutPromotionsRoute
  '/$store/returns': typeof StoreLayoutReturnsRoute
  '/$store/reviews': typeof StoreLayoutReviewsRoute
  '/$store/settings': typeof StoreLayoutSettingsRoute
  '/$store/site-customization': typeof StoreLayoutSiteCustomizationRoute
  '/$store/tags': typeof StoreLayoutTagsRoute
  '/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/reset-password': typeof AuthAuthLayoutResetPasswordRoute
  '/signin': typeof AuthAuthLayoutSigninRoute
  '/$store': typeof StoreLayoutIndexRoute
  '/$store/admin/feature-announcements': typeof StoreLayoutAdminFeatureAnnouncementsRoute
  '/$store/admin/payment-methods': typeof StoreLayoutAdminPaymentMethodsRoute
  '/$store/admin/shipping-methods': typeof StoreLayoutAdminShippingMethodsRoute
  '/$store/orders/$orderId': typeof StoreLayoutOrdersOrderIdRoute
  '/$store/products/add': typeof StoreLayoutProductsAddRoute
  '/$store/settings/api': typeof StoreLayoutSettingsApiRoute
  '/$store/settings/general': typeof StoreLayoutSettingsGeneralRoute
  '/$store/settings/payment': typeof StoreLayoutSettingsPaymentRoute
  '/$store/settings/seo': typeof StoreLayoutSettingsSeoRoute
  '/$store/settings/shipping': typeof StoreLayoutSettingsShippingRoute
  '/$store/settings/team': typeof StoreLayoutSettingsTeamRoute
  '/$store/admin/feature-announcements/new': typeof StoreLayoutAdminFeatureAnnouncementsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/onboarding': typeof OnboardingRoute
  '/$store/_layout': typeof StoreLayoutRouteWithChildren
  '/_auth/_auth-layout': typeof AuthAuthLayoutRouteWithChildren
  '/$store/_layout/attributes': typeof StoreLayoutAttributesRoute
  '/$store/_layout/categories': typeof StoreLayoutCategoriesRoute
  '/$store/_layout/collections': typeof StoreLayoutCollectionsRoute
  '/$store/_layout/coupons': typeof StoreLayoutCouponsRoute
  '/$store/_layout/customers': typeof StoreLayoutCustomersRoute
  '/$store/_layout/images': typeof StoreLayoutImagesRoute
  '/$store/_layout/orders': typeof StoreLayoutOrdersRoute
  '/$store/_layout/personalization': typeof StoreLayoutPersonalizationRoute
  '/$store/_layout/production': typeof StoreLayoutProductionRoute
  '/$store/_layout/products': typeof StoreLayoutProductsRoute
  '/$store/_layout/promotions': typeof StoreLayoutPromotionsRoute
  '/$store/_layout/returns': typeof StoreLayoutReturnsRoute
  '/$store/_layout/reviews': typeof StoreLayoutReviewsRoute
  '/$store/_layout/settings': typeof StoreLayoutSettingsRoute
  '/$store/_layout/site-customization': typeof StoreLayoutSiteCustomizationRoute
  '/$store/_layout/tags': typeof StoreLayoutTagsRoute
  '/_auth/_auth-layout/forgot-password': typeof AuthAuthLayoutForgotPasswordRoute
  '/_auth/_auth-layout/reset-password': typeof AuthAuthLayoutResetPasswordRoute
  '/_auth/_auth-layout/signin': typeof AuthAuthLayoutSigninRoute
  '/$store/_layout/': typeof StoreLayoutIndexRoute
  '/$store/_layout/admin_/feature-announcements': typeof StoreLayoutAdminFeatureAnnouncementsRoute
  '/$store/_layout/admin_/payment-methods': typeof StoreLayoutAdminPaymentMethodsRoute
  '/$store/_layout/admin_/shipping-methods': typeof StoreLayoutAdminShippingMethodsRoute
  '/$store/_layout/orders_/$orderId': typeof StoreLayoutOrdersOrderIdRoute
  '/$store/_layout/products_/add': typeof StoreLayoutProductsAddRoute
  '/$store/_layout/settings_/api': typeof StoreLayoutSettingsApiRoute
  '/$store/_layout/settings_/general': typeof StoreLayoutSettingsGeneralRoute
  '/$store/_layout/settings_/payment': typeof StoreLayoutSettingsPaymentRoute
  '/$store/_layout/settings_/seo': typeof StoreLayoutSettingsSeoRoute
  '/$store/_layout/settings_/shipping': typeof StoreLayoutSettingsShippingRoute
  '/$store/_layout/settings_/team': typeof StoreLayoutSettingsTeamRoute
  '/$store/_layout/admin_/feature-announcements_/new': typeof StoreLayoutAdminFeatureAnnouncementsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/onboarding'
    | '/$store'
    | '/'
    | '/$store/attributes'
    | '/$store/categories'
    | '/$store/collections'
    | '/$store/coupons'
    | '/$store/customers'
    | '/$store/images'
    | '/$store/orders'
    | '/$store/personalization'
    | '/$store/production'
    | '/$store/products'
    | '/$store/promotions'
    | '/$store/returns'
    | '/$store/reviews'
    | '/$store/settings'
    | '/$store/site-customization'
    | '/$store/tags'
    | '/forgot-password'
    | '/reset-password'
    | '/signin'
    | '/$store/'
    | '/$store/admin/feature-announcements'
    | '/$store/admin/payment-methods'
    | '/$store/admin/shipping-methods'
    | '/$store/orders/$orderId'
    | '/$store/products/add'
    | '/$store/settings/api'
    | '/$store/settings/general'
    | '/$store/settings/payment'
    | '/$store/settings/seo'
    | '/$store/settings/shipping'
    | '/$store/settings/team'
    | '/$store/admin/feature-announcements/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/onboarding'
    | '/'
    | '/$store/attributes'
    | '/$store/categories'
    | '/$store/collections'
    | '/$store/coupons'
    | '/$store/customers'
    | '/$store/images'
    | '/$store/orders'
    | '/$store/personalization'
    | '/$store/production'
    | '/$store/products'
    | '/$store/promotions'
    | '/$store/returns'
    | '/$store/reviews'
    | '/$store/settings'
    | '/$store/site-customization'
    | '/$store/tags'
    | '/forgot-password'
    | '/reset-password'
    | '/signin'
    | '/$store'
    | '/$store/admin/feature-announcements'
    | '/$store/admin/payment-methods'
    | '/$store/admin/shipping-methods'
    | '/$store/orders/$orderId'
    | '/$store/products/add'
    | '/$store/settings/api'
    | '/$store/settings/general'
    | '/$store/settings/payment'
    | '/$store/settings/seo'
    | '/$store/settings/shipping'
    | '/$store/settings/team'
    | '/$store/admin/feature-announcements/new'
  id:
    | '__root__'
    | '/onboarding'
    | '/$store/_layout'
    | '/_auth/_auth-layout'
    | '/$store/_layout/attributes'
    | '/$store/_layout/categories'
    | '/$store/_layout/collections'
    | '/$store/_layout/coupons'
    | '/$store/_layout/customers'
    | '/$store/_layout/images'
    | '/$store/_layout/orders'
    | '/$store/_layout/personalization'
    | '/$store/_layout/production'
    | '/$store/_layout/products'
    | '/$store/_layout/promotions'
    | '/$store/_layout/returns'
    | '/$store/_layout/reviews'
    | '/$store/_layout/settings'
    | '/$store/_layout/site-customization'
    | '/$store/_layout/tags'
    | '/_auth/_auth-layout/forgot-password'
    | '/_auth/_auth-layout/reset-password'
    | '/_auth/_auth-layout/signin'
    | '/$store/_layout/'
    | '/$store/_layout/admin_/feature-announcements'
    | '/$store/_layout/admin_/payment-methods'
    | '/$store/_layout/admin_/shipping-methods'
    | '/$store/_layout/orders_/$orderId'
    | '/$store/_layout/products_/add'
    | '/$store/_layout/settings_/api'
    | '/$store/_layout/settings_/general'
    | '/$store/_layout/settings_/payment'
    | '/$store/_layout/settings_/seo'
    | '/$store/_layout/settings_/shipping'
    | '/$store/_layout/settings_/team'
    | '/$store/_layout/admin_/feature-announcements_/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  OnboardingRoute: typeof OnboardingRoute
  StoreLayoutRoute: typeof StoreLayoutRouteWithChildren
  AuthAuthLayoutRoute: typeof AuthAuthLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$store/_layout': {
      id: '/$store/_layout'
      path: '/$store'
      fullPath: '/$store'
      preLoaderRoute: typeof StoreLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_auth-layout': {
      id: '/_auth/_auth-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthAuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$store/_layout/': {
      id: '/$store/_layout/'
      path: '/'
      fullPath: '/$store/'
      preLoaderRoute: typeof StoreLayoutIndexRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/attributes': {
      id: '/$store/_layout/attributes'
      path: '/attributes'
      fullPath: '/$store/attributes'
      preLoaderRoute: typeof StoreLayoutAttributesRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/categories': {
      id: '/$store/_layout/categories'
      path: '/categories'
      fullPath: '/$store/categories'
      preLoaderRoute: typeof StoreLayoutCategoriesRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/collections': {
      id: '/$store/_layout/collections'
      path: '/collections'
      fullPath: '/$store/collections'
      preLoaderRoute: typeof StoreLayoutCollectionsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/coupons': {
      id: '/$store/_layout/coupons'
      path: '/coupons'
      fullPath: '/$store/coupons'
      preLoaderRoute: typeof StoreLayoutCouponsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/customers': {
      id: '/$store/_layout/customers'
      path: '/customers'
      fullPath: '/$store/customers'
      preLoaderRoute: typeof StoreLayoutCustomersRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/images': {
      id: '/$store/_layout/images'
      path: '/images'
      fullPath: '/$store/images'
      preLoaderRoute: typeof StoreLayoutImagesRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/orders': {
      id: '/$store/_layout/orders'
      path: '/orders'
      fullPath: '/$store/orders'
      preLoaderRoute: typeof StoreLayoutOrdersRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/personalization': {
      id: '/$store/_layout/personalization'
      path: '/personalization'
      fullPath: '/$store/personalization'
      preLoaderRoute: typeof StoreLayoutPersonalizationRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/production': {
      id: '/$store/_layout/production'
      path: '/production'
      fullPath: '/$store/production'
      preLoaderRoute: typeof StoreLayoutProductionRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/products': {
      id: '/$store/_layout/products'
      path: '/products'
      fullPath: '/$store/products'
      preLoaderRoute: typeof StoreLayoutProductsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/promotions': {
      id: '/$store/_layout/promotions'
      path: '/promotions'
      fullPath: '/$store/promotions'
      preLoaderRoute: typeof StoreLayoutPromotionsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/returns': {
      id: '/$store/_layout/returns'
      path: '/returns'
      fullPath: '/$store/returns'
      preLoaderRoute: typeof StoreLayoutReturnsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/reviews': {
      id: '/$store/_layout/reviews'
      path: '/reviews'
      fullPath: '/$store/reviews'
      preLoaderRoute: typeof StoreLayoutReviewsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings': {
      id: '/$store/_layout/settings'
      path: '/settings'
      fullPath: '/$store/settings'
      preLoaderRoute: typeof StoreLayoutSettingsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/site-customization': {
      id: '/$store/_layout/site-customization'
      path: '/site-customization'
      fullPath: '/$store/site-customization'
      preLoaderRoute: typeof StoreLayoutSiteCustomizationRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/tags': {
      id: '/$store/_layout/tags'
      path: '/tags'
      fullPath: '/$store/tags'
      preLoaderRoute: typeof StoreLayoutTagsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/_auth/_auth-layout/forgot-password': {
      id: '/_auth/_auth-layout/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthAuthLayoutForgotPasswordRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/_auth/_auth-layout/reset-password': {
      id: '/_auth/_auth-layout/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthAuthLayoutResetPasswordRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/_auth/_auth-layout/signin': {
      id: '/_auth/_auth-layout/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthAuthLayoutSigninRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/$store/_layout/admin_/feature-announcements': {
      id: '/$store/_layout/admin_/feature-announcements'
      path: '/admin/feature-announcements'
      fullPath: '/$store/admin/feature-announcements'
      preLoaderRoute: typeof StoreLayoutAdminFeatureAnnouncementsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/admin_/payment-methods': {
      id: '/$store/_layout/admin_/payment-methods'
      path: '/admin/payment-methods'
      fullPath: '/$store/admin/payment-methods'
      preLoaderRoute: typeof StoreLayoutAdminPaymentMethodsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/admin_/shipping-methods': {
      id: '/$store/_layout/admin_/shipping-methods'
      path: '/admin/shipping-methods'
      fullPath: '/$store/admin/shipping-methods'
      preLoaderRoute: typeof StoreLayoutAdminShippingMethodsRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/orders_/$orderId': {
      id: '/$store/_layout/orders_/$orderId'
      path: '/orders/$orderId'
      fullPath: '/$store/orders/$orderId'
      preLoaderRoute: typeof StoreLayoutOrdersOrderIdRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/products_/add': {
      id: '/$store/_layout/products_/add'
      path: '/products/add'
      fullPath: '/$store/products/add'
      preLoaderRoute: typeof StoreLayoutProductsAddRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/api': {
      id: '/$store/_layout/settings_/api'
      path: '/settings/api'
      fullPath: '/$store/settings/api'
      preLoaderRoute: typeof StoreLayoutSettingsApiRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/general': {
      id: '/$store/_layout/settings_/general'
      path: '/settings/general'
      fullPath: '/$store/settings/general'
      preLoaderRoute: typeof StoreLayoutSettingsGeneralRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/payment': {
      id: '/$store/_layout/settings_/payment'
      path: '/settings/payment'
      fullPath: '/$store/settings/payment'
      preLoaderRoute: typeof StoreLayoutSettingsPaymentRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/seo': {
      id: '/$store/_layout/settings_/seo'
      path: '/settings/seo'
      fullPath: '/$store/settings/seo'
      preLoaderRoute: typeof StoreLayoutSettingsSeoRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/shipping': {
      id: '/$store/_layout/settings_/shipping'
      path: '/settings/shipping'
      fullPath: '/$store/settings/shipping'
      preLoaderRoute: typeof StoreLayoutSettingsShippingRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/settings_/team': {
      id: '/$store/_layout/settings_/team'
      path: '/settings/team'
      fullPath: '/$store/settings/team'
      preLoaderRoute: typeof StoreLayoutSettingsTeamRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
    '/$store/_layout/admin_/feature-announcements_/new': {
      id: '/$store/_layout/admin_/feature-announcements_/new'
      path: '/admin/feature-announcements/new'
      fullPath: '/$store/admin/feature-announcements/new'
      preLoaderRoute: typeof StoreLayoutAdminFeatureAnnouncementsNewRouteImport
      parentRoute: typeof StoreLayoutRoute
    }
  }
}

interface StoreLayoutRouteChildren {
  StoreLayoutAttributesRoute: typeof StoreLayoutAttributesRoute
  StoreLayoutCategoriesRoute: typeof StoreLayoutCategoriesRoute
  StoreLayoutCollectionsRoute: typeof StoreLayoutCollectionsRoute
  StoreLayoutCouponsRoute: typeof StoreLayoutCouponsRoute
  StoreLayoutCustomersRoute: typeof StoreLayoutCustomersRoute
  StoreLayoutImagesRoute: typeof StoreLayoutImagesRoute
  StoreLayoutOrdersRoute: typeof StoreLayoutOrdersRoute
  StoreLayoutPersonalizationRoute: typeof StoreLayoutPersonalizationRoute
  StoreLayoutProductionRoute: typeof StoreLayoutProductionRoute
  StoreLayoutProductsRoute: typeof StoreLayoutProductsRoute
  StoreLayoutPromotionsRoute: typeof StoreLayoutPromotionsRoute
  StoreLayoutReturnsRoute: typeof StoreLayoutReturnsRoute
  StoreLayoutReviewsRoute: typeof StoreLayoutReviewsRoute
  StoreLayoutSettingsRoute: typeof StoreLayoutSettingsRoute
  StoreLayoutSiteCustomizationRoute: typeof StoreLayoutSiteCustomizationRoute
  StoreLayoutTagsRoute: typeof StoreLayoutTagsRoute
  StoreLayoutIndexRoute: typeof StoreLayoutIndexRoute
  StoreLayoutAdminFeatureAnnouncementsRoute: typeof StoreLayoutAdminFeatureAnnouncementsRoute
  StoreLayoutAdminPaymentMethodsRoute: typeof StoreLayoutAdminPaymentMethodsRoute
  StoreLayoutAdminShippingMethodsRoute: typeof StoreLayoutAdminShippingMethodsRoute
  StoreLayoutOrdersOrderIdRoute: typeof StoreLayoutOrdersOrderIdRoute
  StoreLayoutProductsAddRoute: typeof StoreLayoutProductsAddRoute
  StoreLayoutSettingsApiRoute: typeof StoreLayoutSettingsApiRoute
  StoreLayoutSettingsGeneralRoute: typeof StoreLayoutSettingsGeneralRoute
  StoreLayoutSettingsPaymentRoute: typeof StoreLayoutSettingsPaymentRoute
  StoreLayoutSettingsSeoRoute: typeof StoreLayoutSettingsSeoRoute
  StoreLayoutSettingsShippingRoute: typeof StoreLayoutSettingsShippingRoute
  StoreLayoutSettingsTeamRoute: typeof StoreLayoutSettingsTeamRoute
  StoreLayoutAdminFeatureAnnouncementsNewRoute: typeof StoreLayoutAdminFeatureAnnouncementsNewRoute
}

const StoreLayoutRouteChildren: StoreLayoutRouteChildren = {
  StoreLayoutAttributesRoute: StoreLayoutAttributesRoute,
  StoreLayoutCategoriesRoute: StoreLayoutCategoriesRoute,
  StoreLayoutCollectionsRoute: StoreLayoutCollectionsRoute,
  StoreLayoutCouponsRoute: StoreLayoutCouponsRoute,
  StoreLayoutCustomersRoute: StoreLayoutCustomersRoute,
  StoreLayoutImagesRoute: StoreLayoutImagesRoute,
  StoreLayoutOrdersRoute: StoreLayoutOrdersRoute,
  StoreLayoutPersonalizationRoute: StoreLayoutPersonalizationRoute,
  StoreLayoutProductionRoute: StoreLayoutProductionRoute,
  StoreLayoutProductsRoute: StoreLayoutProductsRoute,
  StoreLayoutPromotionsRoute: StoreLayoutPromotionsRoute,
  StoreLayoutReturnsRoute: StoreLayoutReturnsRoute,
  StoreLayoutReviewsRoute: StoreLayoutReviewsRoute,
  StoreLayoutSettingsRoute: StoreLayoutSettingsRoute,
  StoreLayoutSiteCustomizationRoute: StoreLayoutSiteCustomizationRoute,
  StoreLayoutTagsRoute: StoreLayoutTagsRoute,
  StoreLayoutIndexRoute: StoreLayoutIndexRoute,
  StoreLayoutAdminFeatureAnnouncementsRoute:
    StoreLayoutAdminFeatureAnnouncementsRoute,
  StoreLayoutAdminPaymentMethodsRoute: StoreLayoutAdminPaymentMethodsRoute,
  StoreLayoutAdminShippingMethodsRoute: StoreLayoutAdminShippingMethodsRoute,
  StoreLayoutOrdersOrderIdRoute: StoreLayoutOrdersOrderIdRoute,
  StoreLayoutProductsAddRoute: StoreLayoutProductsAddRoute,
  StoreLayoutSettingsApiRoute: StoreLayoutSettingsApiRoute,
  StoreLayoutSettingsGeneralRoute: StoreLayoutSettingsGeneralRoute,
  StoreLayoutSettingsPaymentRoute: StoreLayoutSettingsPaymentRoute,
  StoreLayoutSettingsSeoRoute: StoreLayoutSettingsSeoRoute,
  StoreLayoutSettingsShippingRoute: StoreLayoutSettingsShippingRoute,
  StoreLayoutSettingsTeamRoute: StoreLayoutSettingsTeamRoute,
  StoreLayoutAdminFeatureAnnouncementsNewRoute:
    StoreLayoutAdminFeatureAnnouncementsNewRoute,
}

const StoreLayoutRouteWithChildren = StoreLayoutRoute._addFileChildren(
  StoreLayoutRouteChildren,
)

interface AuthAuthLayoutRouteChildren {
  AuthAuthLayoutForgotPasswordRoute: typeof AuthAuthLayoutForgotPasswordRoute
  AuthAuthLayoutResetPasswordRoute: typeof AuthAuthLayoutResetPasswordRoute
  AuthAuthLayoutSigninRoute: typeof AuthAuthLayoutSigninRoute
}

const AuthAuthLayoutRouteChildren: AuthAuthLayoutRouteChildren = {
  AuthAuthLayoutForgotPasswordRoute: AuthAuthLayoutForgotPasswordRoute,
  AuthAuthLayoutResetPasswordRoute: AuthAuthLayoutResetPasswordRoute,
  AuthAuthLayoutSigninRoute: AuthAuthLayoutSigninRoute,
}

const AuthAuthLayoutRouteWithChildren = AuthAuthLayoutRoute._addFileChildren(
  AuthAuthLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  OnboardingRoute: OnboardingRoute,
  StoreLayoutRoute: StoreLayoutRouteWithChildren,
  AuthAuthLayoutRoute: AuthAuthLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
